module.exports = __webpack_public_path__ + "static/media/adelaide.71f617a6.png";